export default "__VITE_ASSET__CwgL038a__"